export const ROUTES = {
  home: "/",
  features: "/features",
  contact: "/contact",
  pricing: "/pricing",
  support: "/support",
  notFound: "/404",
  privacyPolicy: "/privacy-policy",
  getStarted: "/get-started",
};
